import { render, staticRenderFns } from "./AnswerTable.vue?vue&type=template&id=6d0c7600&scoped=true&"
import script from "./AnswerTable.vue?vue&type=script&lang=ts&"
export * from "./AnswerTable.vue?vue&type=script&lang=ts&"
import style0 from "./AnswerTable.vue?vue&type=style&index=0&id=6d0c7600&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d0c7600",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VTextarea } from 'vuetify/lib/components/VTextarea';
installComponents(component, {VTextarea})
